/**
 * The menu's live counts — `{badge: count}` from `/auth/navigation/badges`.
 *
 * The server counts only the badges on modules this person is shown, so a
 * count the permission or the installation withholds never arrives and its
 * menu entry stays plain. Every audited change refetches it (`always` in
 * `REALTIME_TABLE`); the interval catches what no change announces — a
 * client's deadline passing in the night.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@connect/web-shared';

export const NAV_BADGES_KEY = ['navigation', 'badges'] as const;

const EVERY_FIVE_MINUTES = 5 * 60_000;

export function useNavBadges(): Record<string, number> | undefined {
  const counts = useQuery({
    queryKey: NAV_BADGES_KEY,
    queryFn: () => api.get<Record<string, number>>('/auth/navigation/badges'),
    refetchInterval: EVERY_FIVE_MINUTES,
  });
  return counts.data;
}
